import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { useTranslation } from "react-i18next";
import { LLMTrackerStore } from "../../../store/LLMTrackerStore";
import { ZustandStore } from "../../../store/zustand-store";

const LLMProjectList = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [filter, setFilter] = useState("");
  const { SELECTED_PROJECT, USER_LLM_PROJECT } = LLMTrackerStore(
    (state) => state
  );

  const projectList = useMemo(() => {
    const uniqueSet = new Set();
    return USER_LLM_PROJECT?.reduce((acc, project) => {
      const key = `${project.weburl}-${project.language_code}`;
      if (!uniqueSet.has(key)) {
        uniqueSet.add(key);
        acc.push(key);
      }
      return acc;
    }, []);
  }, [USER_LLM_PROJECT]);

  const curr_project = SELECTED_PROJECT
    ? `${SELECTED_PROJECT.weburl}-${SELECTED_PROJECT.language_code}`
    : "Select a Project";

  const SelectPrName = (e) => {
    if (location?.pathname === "/guest/llm-tracker") return;
    if (curr_project === "Select a Project" || e === curr_project) return;
    sessionStorage.setItem("LAST_LLMPRPJECT_SELECTED", e);
    ZustandStore.setState({
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
    LLMTrackerStore.setState({
      KEYWORD_LOC_DATA: "",
      KEYWORD_ALL_LOC_DATA: [],
      KEYWORD_LATEST_DATA: [],
      KEYWORD_OLD_DATA: [],
      SELECTED_PROJECT: null,
    });
  };

  const options = useMemo(
    () =>
      projectList?.filter((value) => {
        return value?.toString().toLowerCase().includes(filter.toLowerCase());
      }),
    [filter, projectList]
  );

  return (
    <Flex direction="column">
      <Select
        w="100%"
        value={curr_project}
        onChange={SelectPrName}
        placeholder={curr_project}
        disabled={
          location?.pathname === "/guest/llm-tracker" || !SELECTED_PROJECT
        }
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: "35px",
          }}
          loading={!SELECTED_PROJECT}
        />
        <Select.Popper aria-label={"Project options with search"}>
          <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            {options.map((value) => (
              <Select.Option
                value={value}
                key={value}
                style={{
                  boxShadow: "none",
                }}
              >
                {value}
              </Select.Option>
            ))}
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length}
                {t("rank_tracking.map_rank_tracker.add_first_project.result")}
                {options.length > 1 && "s"}{" "}
                {t("rank_tracking.map_rank_tracker.add_first_project.found")}
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                Nothing{" "}
                {t("rank_tracking.map_rank_tracker.add_first_project.title")}
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default React.memo(LLMProjectList);
